import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "23",
  viewBox: "0 0 22 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M21.7809 7.11406C21.7809 7.11406 21.566 5.59727 20.9043 4.93125C20.0664 4.05469 19.1297 4.05039 18.7 3.99883C15.6234 3.77539 11.0043 3.77539 11.0043 3.77539H10.9957C10.9957 3.77539 6.37656 3.77539 3.3 3.99883C2.87031 4.05039 1.93359 4.05469 1.0957 4.93125C0.433984 5.59727 0.223438 7.11406 0.223438 7.11406C0.223438 7.11406 0 8.89727 0 10.6762V12.3434C0 14.1223 0.219141 15.9055 0.219141 15.9055C0.219141 15.9055 0.433984 17.4223 1.09141 18.0883C1.9293 18.9648 3.0293 18.9348 3.51914 19.0293C5.28086 19.1969 11 19.2484 11 19.2484C11 19.2484 15.6234 19.2398 18.7 19.0207C19.1297 18.9691 20.0664 18.9648 20.9043 18.0883C21.566 17.4223 21.7809 15.9055 21.7809 15.9055C21.7809 15.9055 22 14.1266 22 12.3434V10.6762C22 8.89727 21.7809 7.11406 21.7809 7.11406ZM8.72695 14.3672V8.18398L14.6695 11.2863L8.72695 14.3672Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }